import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import NoticeModal from "views/components/NoticeModal";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgress from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomTextField from "components/UpdateUi/CustomeTextField";
import CustomSelectNew from "../../../../components/UpdateUi/CustomeSelect";

const WeighageControllerScoreCreate = ({
  classes,
  WeighageAllocationShow,
  weighageId,
  setWeighageId,
  onClose,
  rawData,
}) => {
  const navigate = useNavigate();
  const [scoreOutOfHundred, setScoreOutOfHundred] = useState("");
  const [scoreOutOfHundredState, setScoreOutOfHundredState] = useState(false);
  const [rangeFrom,setRangeFrom]=useState("")
  const [rangeFromState,setRangeFromState]=useState("")
  const [rangeTo,setRangeTo]=useState("")
  const [rangeToState,setRangeToState]=useState("")
  const [param, setParam] = useState("");
  const [paramState, setParamState] = useState(false);
  const [noticeModal, setNoticeModal] = useState(false);
  const [noticeModalErrMsg, setNoticeModalErrMsg] = useState("");
  const [noticeModalHeaderMsg, setNoticeModalHeaderMsg] = useState("");
  const [redirectURL, setRedirectURL] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [isValid, setIsValid] = useState(true);

  const [callInProgress, setCallInProgress] = useState(false);
  const paramList = [
    { code: "CIBIL", name: "CIBIL" },
    { code: "SALARY", name: "SALARY" },
    { code: "DURATION IN CURRENT COMPANY", name: "DURATION IN CURRENT COMPANY" },
    { code: "APPLICANT AGE", name: "APPLICANT AGE" },
  ];
  const closeNoticeModal = () => {
    setNoticeModal(false);
    setNoticeModalErrMsg("");
    setNoticeModalHeaderMsg("");
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  const isValidated = () => {
    if (param === "") {
      setParamState(true);
    } else {
      setParamState(false);
    }
    if (scoreOutOfHundred === "") {
      setScoreOutOfHundredState(true);
    } else {
      setScoreOutOfHundredState(false);
    }
    if (rangeFrom === "") {
      setRangeFromState(true);
    } else {
        setRangeFromState(false);
    }
    if (rangeTo === "") {
      setRangeToState(true);
    } else {
      setRangeToState(false);
    }
    if (scoreOutOfHundred === "" || param === "" || rangeFrom === "" || rangeTo === "") {
      setIsValid(false)
      return false;
    } else {
      return true;
    }
  };
  useEffect(() => {
    if (weighageId) {
      GetData();
    }
  }, []);

  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.MASTER_WEIGHTAGE_SCORE_CONTROLLER_FIND_BY_ID + weighageId,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      setNoticeModalErrMsg(result?.data?.user_description);
      setNoticeModalHeaderMsg("Error");
      setNoticeModal(true);
    } else {
      setScoreOutOfHundred(result?.data?.scoreOutOf100);
      setParam(result?.data?.ruleParam);
      setRangeFrom(result?.data?.rangeFrom)
      setRangeTo(result?.data?.rangeTo)
    }
  };

  const handleCreateSubmit = async (event) => {
    if (isValidated()) {
      setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.MASTER_WEIGHTAGE_SCORE_CONTROLLER_CREATE,
        method: "POST",
        authToken: authToken,
        data: {
          ruleParam: param,
          scoreOutOf100: parseInt(scoreOutOfHundred),
          rangeFrom: parseInt(rangeFrom),
          rangeTo: parseInt(rangeTo),
        },
      });
      setCallInProgress(false);
      if (res?.data?.error_code) {
        setNoticeModalErrMsg(res?.data?.user_description);
        setNoticeModalHeaderMsg("Error");
        setNoticeModal(true);
        return;
      } else {
        onClose("create");
        WeighageAllocationShow(true);
      }
    }
  };

  const handleEditSubmit = async (event) => {
    if (isValidated()) {
      setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.MASTER_WEIGHTAGE_SCORE_CONTROLLER_UPDATE + weighageId,
        method: "PUT",
        authToken: authToken,
        data: {
            ruleParam: param,
            scoreOutOf100: parseInt(scoreOutOfHundred),
            rangeFrom: parseInt(rangeFrom),
            rangeTo: parseInt(rangeTo),
        },
      });
      setCallInProgress(false);
      if (res?.data?.error_code) {
        setNoticeModalErrMsg(res?.data?.user_description);
        setNoticeModalHeaderMsg("Error");
        setNoticeModal(true);
        return;
      } else {
        onClose("update");
        WeighageAllocationShow(true);
      }
    }
  };
  const handleCancel = () => {
    WeighageAllocationShow(true);
    setWeighageId("");
  };

  const handleScoreValue = (e) => {
    if(e>100){
        setNoticeModalErrMsg("Score value cant't be grater than 100");
        setNoticeModalHeaderMsg("Error");
        setNoticeModal(true);
        setScoreOutOfHundred(0)
    }
  };

  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={
            weighageId ? "Edit Weightage Score" : "Create Weightage Score"
          }
          button1=" Save"
          button2=" Cancel"
          button1click={weighageId ? handleEditSubmit : handleCreateSubmit}
          button2click={handleCancel}
          // disabled1={isValid}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} className={classes?.inputContainer}>
        <Grid container className={classes?.inputFieldContainer}>
          <Grid xs={12} sm={12} md={4} className={classes?.fieldContaienr}>
            <CustomSelectNew
              label="Param*"
              error={paramState}
              value={param}
              setState={setParam}
              data={paramList}
              setError={setParamState}
              type = "newSchemeCharge"
            />
          </Grid>
          <Grid xs={12} sm={6} md={4} className={classes?.fieldContaienr}>
            <CustomTextField
              label="Range From"
              required
              error={rangeFromState}
              id="lp_branch_code"
              value={rangeFrom || ""}
              setState={setRangeFrom}
              setError={setRangeFromState}
            />
          </Grid>
          <Grid xs={12} sm={6} md={4} className={classes?.fieldContaienr}>
            <CustomTextField
              label="Range To"
              required
              error={rangeToState}
              id="lp_branch_code"
              value={rangeTo || ""}
              setState={setRangeTo}
              setError={setRangeToState}
            />
          </Grid>
          <Grid xs={12} sm={6} md={4} className={classes?.fieldContaienr}>
            <CustomTextField
              label="Score Out of 100"
              required
              error={scoreOutOfHundredState}
              id="lp_branch_code"
              value={scoreOutOfHundred || ""}
              setState={setScoreOutOfHundred}
              setError={setScoreOutOfHundredState}
              setBlur={handleScoreValue}
            />
          </Grid>
        </Grid>
      </Grid>
      {callInProgress && <CircularProgress callInProgress={callInProgress} />}
      <NoticeModal
        noticeModal={noticeModal}
        noticeModalHeader={noticeModalHeaderMsg}
        noticeModalErrMsg={noticeModalErrMsg}
        closeModal={closeNoticeModal}
      />
    </Grid>
  );
};

WeighageControllerScoreCreate.propTypes = {
  classes: PropTypes.object,
};

export default WeighageControllerScoreCreate;
